export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topbar-menu.vue?vue&type=template&id=5865da14"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-menu.vue?vue&type=template&id=5865da14
// module id = T91W
// module chunks = 0